import qs from 'qs';
import { useCallback } from 'react';
import { getGetOpenwebMetodoIdpAuthReqQueryKey } from '../../api/login-openweb-controller/login-openweb-controller';
import type { GetOpenwebMetodoIdpAuthReqParams } from '../../api/schemas/getOpenwebMetodoIdpAuthReqParams';

export type ProfessionalSpidPurpose = 'P' | 'LP' | 'PX';

/**
 * Funzione per l'identity provider utile per il redirect ai servizi SPID
 * @description Aggiornare in caso di nuovi provider
 */
export function getIdentityProvider(entityId: string) {
  switch (entityId) {
    case 'https://posteid.poste.it':
      return 'poste';
    case 'https://loginspid.aruba.it':
      return 'arubaid';
    case 'https://spid.intesa.it':
      return 'intesa';
    case 'https://identity.infocert.it':
      return 'infocert';
    case 'https://id.lepida.it/idp/shibboleth':
      return 'lepida';
    case 'https://idp.namirialtsp.com/idp':
      return 'namirialid';
    case 'https://spid.register.it':
      return 'spiditalia';
    case 'https://identity.sieltecloud.it':
      return 'sielte';
    case 'https://login.id.tim.it/affwebservices/public/saml2sso':
      return 'tim';
    case 'https://spid.teamsystem.com/idp':
      return 'teamsystemid';
    case 'https://id.eht.eu':
      return 'etnahitech';
    case 'https://loginspid.infocamere.it':
      return 'infocamere';
    default:
      return entityId;
  }
}

export function getIdpAuthUrl(props: {
  idpMethod: 'SPID' | 'CIE';
  resolvePublicUrl: (path: string) => string;
  entityId?: string | null;
  purpose?: ProfessionalSpidPurpose;
}) {
  const { idpMethod, resolvePublicUrl, entityId, purpose } = props;
  const params: GetOpenwebMetodoIdpAuthReqParams = {
    ...(entityId ? { idp: getIdentityProvider(entityId) } : {}),
    ...(purpose ? { purpose } : {}),
  };
  const hasParams = Object.keys(params).length > 0;
  const baseUrl = getGetOpenwebMetodoIdpAuthReqQueryKey(
    idpMethod,
    hasParams ? params : undefined,
  );
  let url = baseUrl[0];
  if (hasParams) {
    url += qs.stringify(baseUrl[1], { addQueryPrefix: true });
  }
  return resolvePublicUrl(url);
}

/**
 * Ritorna la funzione per generare il link di autenticazione per un IdP
 */
export function useGetIdpAuthUrlFn(props: {
  idpMethod: 'SPID' | 'CIE';
  resolvePublicUrl: (path: string) => string;
  purpose?: ProfessionalSpidPurpose;
}) {
  const { idpMethod, resolvePublicUrl, purpose } = props;
  return useCallback(
    (entityId: string) => {
      return getIdpAuthUrl({ idpMethod, resolvePublicUrl, entityId, purpose });
    },
    [idpMethod, resolvePublicUrl, purpose],
  );
}
